<template>
  <div class="rj-col-1">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        是否使用扣点：
      </div>
      <div class="rj-baseinfo__item">
        <el-form-item style="display: inline-block">
          <el-radio-group v-model="isUsed" @change="changisRebate">
            <el-radio :label="true">
              是
            </el-radio>
            <el-radio :label="false">
              否
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="isUsed">
          <el-input-number v-model="discount" :controls="false" :min="0" :max="100" label="描述文字" style="margin-left: 15px" @change="changrebateAmount" />
        </template>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { numDiv, Subtr } from '@/libs/util';
export default {
  data () {
    return {
      isUsed: false,
      discount: 0
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {},
  methods: {
    changisRebate (val) {
      if (!val) {
        this.form.rebate = 1;
        this.discount = 0;
      }
    },
    changrebateAmount (val) {
      this.form.rebate = Number(Subtr(1, numDiv(val, 100)));
    }
  },
  mounted () {

  }
};
</script>
